// Photo checks for equipment (the Add equipment panel and the equipment page),
// so both say the same thing about a wrong type or size before uploading.

// Photo types the server accepts (the same as the other image uploads).
export const PHOTO_TYPES = ['jpg', 'jpeg', 'png', 'gif'];
export const PHOTO_ACCEPT = PHOTO_TYPES.map((type) => `.${type}`).join(',');
export const PHOTO_MAX_MB = 10;

// How to name a photo type in a message (iPhones save HEIC, browsers WebP).
const TYPE_NAMES = { webp: 'WebP', heic: 'HEIC', heif: 'HEIF', tif: 'TIFF', tiff: 'TIFF', bmp: 'BMP', avif: 'AVIF' };

export const extensionOf = (name = '') => {
  const match = /\.([a-z0-9]+)$/i.exec(name);
  return match ? match[1].toLowerCase() : '';
};

// What's wrong with a picked file, or null when it can be uploaded.
export const photoProblem = (file) => {
  const type = extensionOf(file.name);
  if (!PHOTO_TYPES.includes(type)) {
    const what = type ? `${TYPE_NAMES[type] || type.toUpperCase()} photos` : 'This file';
    return `${what} can’t be added. Use a JPG, PNG or GIF. Most phones can share a photo as JPG.`;
  }
  const sizeMb = file.size / 1024 / 1024;
  if (sizeMb > PHOTO_MAX_MB) {
    return `This photo is ${sizeMb.toFixed(1)} MB. Photos can be up to ${PHOTO_MAX_MB} MB.`;
  }
  return null;
};

// A failed upload's message, whatever shape the API sent it in.
export const uploadErrorText = (error) => {
  const errors = error && error.response && error.response.data && error.response.data.errors;
  const flat = (value) => {
    if (!value) return [];
    if (typeof value === 'string') return [value];
    if (Array.isArray(value)) return value.flatMap(flat);
    if (typeof value === 'object') return Object.values(value).flatMap(flat);
    return [String(value)];
  };
  const messages = flat(errors);
  return messages.length ? messages.join(' ') : 'The photo couldn’t be uploaded. Check your connection and try again.';
};

// An image record's urls; null when it has no file (it can't be shown).
export const photoUrls = (image) => {
  const asset = image && image.asset;
  if (!asset || !asset.url) return null;
  return { src: asset.url, thumbnail: (asset.thumb && asset.thumb.url) || asset.url, id: image.id };
};
